export function titleize(val?: string | null) {
  return val ? val.replace(/[-_]+/g, ' ').replace(/(?:^| )[\w]/g, (matched) => matched.toLocaleUpperCase()) : val;
}
